// tslint:disable-next-line: no-submodule-imports
import withStyles from 'isomorphic-style-loader/withStyles';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ContextMenuButton from "../components/ContextMenuButton";
import SearchBox from '../components/SearchBox';
import { WINDOW_SIZE_ENUM } from '../types/IWindowSize';
import { MENU_DROPDOWN_TEMPLATE } from '../types/templates/chrome/ISkyfireChromeTemplateMenuDropdown';
import { MENU_ITEM_TEMPLATE } from '../types/templates/chrome/ISkyfireChromeTemplateMenuItem';
import { MENU_TEMPLATE } from '../types/templates/menu';
import { SUB_NAV_TEMPLATE } from '../types/templates/subNav';
import { dispatchSkyfireMethods, globals } from '../utils';
import * as Styles from './Navbar.scss';
import NavBarSettings from './NavBarSettings';
import { isDesktop } from "../utils/platform";
class Navbar extends Component {
    constructor() {
        super(...arguments);
        this.getMenuItem = (template, item, idx, menuItems) => {
            var _a;
            const { windowWidth, isSearchBoxFocused } = this.props;
            const threeButtons = ((_a = menuItems) === null || _a === void 0 ? void 0 : _a.length) >= 3;
            const stackedButtonBreakPoint = threeButtons ? WINDOW_SIZE_ENUM.XL3 : WINDOW_SIZE_ENUM.XL2;
            const isStackedButton = !threeButtons && windowWidth <= stackedButtonBreakPoint;
            const iconOnly = isSearchBoxFocused || threeButtons ? windowWidth < WINDOW_SIZE_ENUM.XL3 : windowWidth < WINDOW_SIZE_ENUM.LG;
            if (item.interface === MENU_ITEM_TEMPLATE) {
                const menuItem = item;
                const isActive = this.isActive(template, menuItem.primaryLink.deeplink);
                return (React.createElement("li", null,
                    React.createElement("music-button", { id: `navbarMenuItem${idx + 1}`, className: threeButtons ? Styles.textIconButton3 : Styles.textIconButton, "icon-name": menuItem.icon, variant: isActive ? 'accent' : 'primary', onmusicActivate: this.handleSelected.bind(this, isActive ? [] : menuItem.primaryLink.onItemSelected), size: isStackedButton || iconOnly ? 'medium' : 'large', href: menuItem.primaryLink.deeplink, stacked: isStackedButton, iconOnly: iconOnly }, menuItem.altText),
                    React.createElement("music-button", { id: `navbarMenuItem${idx + 1}`, className: threeButtons ? Styles.noTextIconButton3 : Styles.noTextIconButton, "icon-name": menuItem.icon, variant: isActive ? 'accent' : 'primary', onmusicActivate: this.handleSelected.bind(this, isActive ? [] : menuItem.primaryLink.onItemSelected), size: 'medium', href: menuItem.primaryLink.deeplink, iconOnly: true }, menuItem.altText)));
            }
            else if (item.interface === MENU_DROPDOWN_TEMPLATE) {
                const menuDropdown = item;
                const isActive = menuDropdown.items.some(dropdownItem => this.isActive(template, dropdownItem.primaryLink.deeplink));
                const options = menuDropdown.items.map((dropdownItem) => {
                    const isSelected = this.isSelected(dropdownItem, isActive);
                    return {
                        text: dropdownItem.text,
                        isActive: isSelected,
                        onItemSelected: dropdownItem.primaryLink.onItemSelected,
                        link: dropdownItem.primaryLink
                    };
                });
                return (React.createElement("li", null,
                    React.createElement(ContextMenuButton, { options: options, hover: isDesktop(window), variant: isActive ? 'accent' : 'primary', isRefinement: false, size: iconOnly ? 'medium' : 'large', iconName: menuDropdown.icon, postFixIconName: "caretdown", text: iconOnly ? "" : menuDropdown.text })));
            }
        };
    }
    render() {
        return (React.createElement("nav", { className: Styles.navbar, id: "navbar" }, this.renderNavbarContent()));
    }
    renderNavbarContent() {
        const { id, menuItems, searchBox, logoAltText, logoDeeplink, logoImage, logoImageSmall, logoOnItemSelected, innerTemplate } = this.props.template;
        const { isSearchBoxFocused, windowWidth } = this.props;
        if (isSearchBoxFocused && windowWidth <= WINDOW_SIZE_ENUM.LG) {
            return React.createElement(SearchBox, { searchItem: searchBox, templateId: id });
        }
        return (React.createElement(Fragment, null,
            React.createElement("ul", { className: Styles.navbarNavigationItems },
                React.createElement("li", { className: Styles.navbarLogoContainer },
                    React.createElement("a", { id: "navbarMusicLogo", href: logoDeeplink, onClick: this.handleSelected.bind(this, logoOnItemSelected) },
                        React.createElement("img", { className: Styles.navbarLogoSmall, src: logoImageSmall, alt: logoAltText, crossOrigin: "anonymous" }),
                        React.createElement("img", { className: Styles.navbarLogo, src: logoImage, alt: logoAltText }))),
                menuItems.map(this.getMenuItem.bind(this, innerTemplate)),
                React.createElement(SearchBox, { searchItem: searchBox, templateId: id }),
                React.createElement(AccountButton, { styles: Styles, template: this.props.template, windowWidth: this.props.windowWidth }))));
    }
    handleSelected(onItemSelected, event) {
        var _a, _b, _c, _d, _e, _f, _g;
        (_d = (_b = (_a = event) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : (_c = _b).preventDefault) === null || _d === void 0 ? void 0 : _d.call(_c);
        (_g = (_e = event) === null || _e === void 0 ? void 0 : (_f = _e).preventDefault) === null || _g === void 0 ? void 0 : _g.call(_f);
        const { dispatch, template } = this.props;
        dispatchSkyfireMethods(dispatch, template, onItemSelected);
    }
    isActive(template, itemPath) {
        if (!itemPath) {
            return false;
        }
        let menuItemPaths;
        if (template.interface === MENU_TEMPLATE) {
            const { menuItems } = template;
            menuItemPaths = menuItems.map(item => item.primaryLink.deeplink);
        }
        else if (template.interface === SUB_NAV_TEMPLATE) {
            // Get subnav items from Chrome Template, not the inner template
            const { subNavMenuItems } = this.props.template;
            menuItemPaths = subNavMenuItems.map(item => item.primaryLink.deeplink);
        }
        else {
            menuItemPaths = [globals.location.pathname];
        }
        return menuItemPaths.some(menuItemPath => menuItemPath === itemPath);
    }
    isSelected(dropdownItem, isActive) {
        var _a;
        const currentPath = globals.location.pathname;
        const activePaths = ((_a = dropdownItem) === null || _a === void 0 ? void 0 : _a.activePaths) || [];
        const result = isActive && activePaths.some(activePath => currentPath.startsWith(activePath));
        return result;
    }
}
const AccountButton = ({ styles, template, windowWidth }) => (React.createElement("li", { key: "accountButton", className: styles.accountButton }, template.showSignInButton ? (React.createElement("music-button", { variant: "solid", href: "/forceSignIn?useHorizonte=true", id: "signInButton", style: { margin: '0 10px' } }, template.signInButtonText)) : (React.createElement(NavBarSettings, { template: template, windowWidth: windowWidth }))));
function mapStateToProps(state) {
    return {
        isSearchBoxFocused: state.SearchSuggestions.isSearchBoxFocused,
        windowWidth: state.BrowserState.windowWidth,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withStyles(Styles)(connect(mapStateToProps, mapDispatchToProps)(Navbar));
